import { render, staticRenderFns } from "./belongToConsignment.vue?vue&type=template&id=f9f06790&scoped=true"
import script from "./belongToConsignment.vue?vue&type=script&lang=js"
export * from "./belongToConsignment.vue?vue&type=script&lang=js"
import style0 from "./belongToConsignment.vue?vue&type=style&index=0&id=f9f06790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f06790",
  null
  
)

export default component.exports